import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { blogPosts } from '../data/blog';
export function Blog() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="pt-24 pb-20 bg-[#f8f7f6] dark:bg-[#252423] min-h-screen" data-id="element-2263" data-mp="vv2e3hadxu2y">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2264" data-mp="qx0tut183opw">
        <header className="mb-12 text-center" data-id="element-2265" data-mp="37pp70gr5a6h">
          <h1 className="font-heading text-4xl md:text-5xl font-extrabold text-brand-charcoal dark:text-white tracking-tight uppercase" data-id="element-2266" data-mp="38hlkdi6bbxt">
            Blog: Guides & Tips
          </h1>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2267" data-mp="cyaxjfm89t2l">
          {blogPosts.map((post, idx) => <motion.article key={post.slug} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white dark:bg-[#333333] rounded-2xl overflow-hidden shadow-sm border border-stone-200 dark:border-white/10 hover:shadow-md transition-shadow flex flex-col" data-id="element-2268" data-mp="8581n0tza7j8" data-mpi={idx}>
              <Link to={`/blog/${post.slug}`} className="block aspect-video overflow-hidden" data-id="element-2269" data-mp="2735pfdf5mdbo">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-2270" data-mp="2bw8d54x92sjy" />
              </Link>
              <div className="p-6 flex flex-col flex-grow" data-id="element-2271" data-mp="1j6rmabpa3jpu">
                <p className="text-sm text-brand-muted dark:text-stone-400 italic mb-2" data-id="element-2272" data-mp="1j8cevvs18sl2">
                  {post.date}
                </p>
                <Link to={`/blog/${post.slug}`} data-id="element-2273" data-mp="1s7fyr1z0xc0m">
                  <h2 className="font-heading text-xl font-extrabold text-brand-charcoal dark:text-white uppercase mb-3 hover:text-brand-orange transition-colors" data-id="element-2274" data-mp="1s5muftbvv3vs">
                    {post.title}
                  </h2>
                </Link>
                <p className="text-brand-muted dark:text-stone-300 text-sm leading-relaxed flex-grow" data-id="element-2275" data-mp="38l65yhlfwgeh">
                  {post.excerpt}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </main>;
}